// ref: https://stackoverflow.com/questions/37866806/defining-constants-in-typescript-ionic-application
// ref: https://ionicallyspeaking.com/2016/04/08/a-central-provider-for-constants-in-ionic-2/

// include these in any code by adding the following line at the top:
//    import * as Constants from './../../providers/common/constants';

// var navOptions = { animate: true, animation: 'ios-transition' }; // 'wp-transition' 
export const NAV_FORWARD = { animate:true, animation:'transition', duration:500, direction:'forward'};
export const NAV_BACK = { animate:true, animation:'transition', duration:500, direction:'back'};
export const NAV_UP = { animate:true, animation:'transition', duration:500, direction:'up'};
export const NAV_DOWN = { animate:true, animation:'transition', duration:500, direction:'down'};
export const NAV_EDIT_FORWARD = { animate:true, animation:'transition', duration:500, direction:'forward'};
export const NAV_EDIT_BACK = { animate:true, animation:'transition', duration:500, direction:'forward'};

export const NAV_SOURCE_ASSIGNED = '/assigned'; 
export const NAV_SOURCE_SUBMITTED = '/submitted';

export const MESSAGE_TITLE_AMBITMESSAGE = 'Ambit Message Alert';
export const MESSAGE_TITLE_EVENTNOTIFICATION = 'Event Notification';

export const NOTIFICATION_TYPE_SURVEY = 'SURVEY';
export const NOTIFICATION_TYPE_ACTIONABLE = 'ACTIONABLE';
export const NOTIFICATION_TYPE_AMBITMESSAGE = 'AMBITMESSAGE';  
export const NOTIFICATION_TYPE_EVENTNOTIFICATION = 'EVENTNOTIFICATION';  
//export const NOTIFICATION_TYPE_CHAT = 'CHAT';
export const NOTIFICATION_TYPE_MONITOR = 'MONITOR';

export const NOTIFICATION_SOURCE_PUSH = 'PUSH';
export const NOTIFICATION_SOURCE_UNSEEN = 'UNSEEN';
export const NOTIFICATION_SOURCE_OTHER = 'OTHER';

// map zoom levels  0 lowest zoom (whole world)
//                  Remote regions of Antarctica: 13
//                  Gobi Desert: 17
//                  Much of the U.S. and Europe: 21
//                  "Deep zoom" locations: 22-23 (see bkaid's link)
export const MAP_ZOOM_00_WHOLE_WORLD = 0;
export const MAP_ZOOM_03_STATE = 3;
export const MAP_ZOOM_06_CITY = 6;
export const MAP_ZOOM_09_BOROUGH = 9;
export const MAP_ZOOM_12_NEIGHBORHOOD = 12;
export const MAP_ZOOM_18_BUILDINGS = 18;
export const MAP_ZOOM_22_CLOSE_UP = 22;

// Live/History display -- also used for Segement status button toggle
export const STATUS_LIVE = 'live';
export const STATUS_HISTORY = 'history';

// Monitor state type constants
export const MONITOR_HELP = 'HELP';
export const MONITOR_ME = 'MONITOR_ME';
export const MONITOR_END = 'END';

// Checkin state type constants
export const CHECKIN_OFF = 'OFF';
export const CHECKIN_BREAK = 'BREAK';
export const CHECKIN_WORK = 'WORK';

export const MONITORING_STATUS_HELP = 'MONITORING HELP';
export const MONITORING_STATUS_MONITOR_ME = 'MONITORING';

// Monitor Session constants
export const MONITOR_SESSION_START = 'START';
export const MONITOR_SESSION_INPROGRESS = 'INPROGRESS';
export const MONITOR_SESSION_END = 'END';
export const MONITOR_FORCE_END_SESSION = 'FORCE_END_SESSION';

// Monitor Chat constants
export const MONITOR_CHAT_USER_MOBILE = 'MOBILE';
export const MONITOR_CHAT_USER_SYSTEM = 'SYSTEM';

// panic app confirmation types  -- compare with PanicConfirmationType
export const PANIC_CONFIRMATION_COUNTDOWN = 'COUNTDOWN';
export const PANIC_CONFIRMATION_MANUAL = 'MANUAL';
export const PANIC_CONFIRMATION_NONE = 'NONE';

// GeoPosition constants
export const GPS = 'GPS';
export const INDOOR = 'IPS';

// GeoPosition constants
export const GEO_WATCH = 'WATCH';
export const GEO_CURRENT = 'CURRENT';

export const GEO_SUCCESS_WATCH = 'Watching';
export const GEO_SUCCESS_CURRENT = 'Position found';

// GeoPosition constants -- These are used as text descriptions as well as for checking values in code
export const WATCH_INITIALIZE = 'Initialize';  // for first time IPS setup 
export const WATCH_MONITOR = 'Monitor';
export const WATCH_MAP = 'Map';
export const WATCH_SETTINGS = 'Settings';
export const WATCH_SURVEY_BROADCAST = 'Survey Broadcast';  // no underlines due to display!
export const WATCH_SURVEY_RESPONSE = 'Survey Response';  // no underlines due to display!
export const WATCH_ACTIONABLE_RESPONSE = 'Actionable Response';  // no underlines due to display!
export const WATCH_REPORT = 'Report';
export const WATCH_SUPPORT = 'Support';
export const WATCH_CHECKIN = 'Checkin';
export const WATCH_MEDIA = 'Media';
export const WATCH_ACCESS = 'Access';
export const WATCH_DOORCONTROL = 'Door Control';
export const WATCH_PULSE = 'Pulse';
export const WATCH_TASK = 'Task';
export const WATCH_EVISITOR = 'eVisitor';
export const WATCH_CONFIDENTIAL = 'Confidential';
export const WATCH_ACTIONS = 'Actions';

// -------------------------------------------------------------------------------------------------------
// Get IndoorAtlas API Key and Secret from here https://app.indooratlas.com/apps
// cordova plugin add https://github.com/IndoorAtlas/cordova-plugin.git
// NOT BEING USED HERE SINCE IndoorAtlas CHANGED THEIR NAMES/APPROACH -- SEE SCRIPT IN INDEX FILE FOR NOW
export const IA_API_KEY = "58064846-eae3-4007-a211-49e501c41fd2"; // p.mx@g  49e501c41fd2
export const IA_API_SECRET = "t73/Pn0osz7R09j6JMs8lzVEMQTc/9C7Wm41pOQVeU1CXc4OzkkRh5E03fTIulfjcL1Vxt1C1c9axmJRVOCaHAAUztVObSsp0XcXitEzT74qCHC28Duwk2FSohN8tQ==";
// NOT BEING USED HERE SINCE IndoorAtlas CHANGED THEIR NAMES/APPROACH -- SEE SCRIPT IN INDEX FILE FOR NOW
// -------------------------------------------------------------------------------------------------------

// GeoPosition constants
export const ALERT_HIGH = 'HIGH';
export const ALERT_WARNING = 'WARNING';
export const ALERT_LOW = 'LOW';

// Theme constants
export const THEME_INITIAL = 'INITIAL';
export const THEME_INSITE = 'INSITE';
export const THEME_MAXXESS = 'MAXXESS';
export const THEME_AMBIT = 'AMBIT';
export const THEME_DARK = 'DARK';
export const THEME_LIGHT = 'LIGHT';
export const THEME_CRAZY = 'CRAZY';

// PushUrl Token constants
export const PUSHTYPE_IOS = 'ios';
export const PUSHTYPE_ANDROID = 'android';

export const SPEC_UNKNOWN = 'unknown';
